import { dialog } from "@/lib/dynamic-dialog-state";
import { ImportConfigsDialog } from "..";

export const importConfigsDialog = dialog(ImportConfigsDialog)